import { authFetch } from "../../utils/authFetch";
import { appUrl } from "../../utils/appHandoff";

const apiURL = require('./apiURL');
const fetch = authFetch;
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];




// types of action
const Types = {
  CREATE_ACCOUNT_CREATING: "CREATE_ACCOUNT_CREATING",
  CREATE_ACCOUNT_USER_CREATED: "CREATE_ACCOUNT_USER_CREATED",
  CREATE_ACCOUNT_USER_CREATION_FAILED: "CREATE_ACCOUNT_USER_CREATION_FAILED",
  CREATE_ACCOUNT_USER_UPDATED: "CREATE_ACCOUNT_USER_UPDATED",
  CREATE_ACCOUNT_USER_UPDATING: "CREATE_ACCOUNT_USER_UPDATING",
  CREATE_ACCOUNT_AC_LEAD: "CREATE_ACCOUNT_AC_LEAD",
  CREATE_ACCOUNT_DEMO_CREATED: "CREATE_ACCOUNT_DEMO_CREATED",
  CREATE_ACCOUNT_SAVING_LEAD: "CREATE_ACCOUNT_SAVING_LEAD",
  CREATE_ACCOUNT_SAVED_LEAD: "CREATE_ACCOUNT_SAVED_LEAD",
  CREATE_ACCOUNT_CONTACT_LISTS: "CREATE_ACCOUNT_CONTACT_LISTS",
  CREATE_ACCOUNT_ADD_TAG: "CREATE_ACCOUNT_ADD_TAG",
  CREATE_ACCOUNT_WEBINAR_SUBSCRIBE: "CREATE_ACCOUNT_WEBINAR_SUBSCRIBE",
  CREATE_ACCOUNT_WEBINAR_SUBSCRIBING: "CREATE_ACCOUNT_WEBINAR_SUBSCRIBING",
};

const userAccountCreated = (response) => ({
  type: Types.CREATE_ACCOUNT_USER_CREATED,
  payload: response,
});

const userAccountCreationFailed = (error) => ({
  type: Types.CREATE_ACCOUNT_USER_CREATION_FAILED,
  error,
});

const creatingAccount = (noOfEmployees,organisation) => ({
  type: Types.CREATE_ACCOUNT_CREATING,
  organisation,
  noOfEmployees
});

const acDealCreated = () => ({
  type: Types.CREATE_ACCOUNT_AC_LEAD,
});

const demoAccountCreated = () => ({
  type: Types.CREATE_ACCOUNT_DEMO_CREATED,
});

const createAccountForServices = (data) => {

    return (dispatch, getState) => {
        const state = getState()

        const {email, password, organisation, noOfEmployees, givenName, familyName, note, jurisdiction, courseSale} = data

        dispatch(creatingAccount(noOfEmployees, organisation))

        if (!(email == "" && state.my && state.my.profile && state.my.profile.email)) {

            fetch(apiURL + '/authentication/create', {
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify({email, password, givenName, familyName,}),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    /*'Organisation': getState().currentOrganisation,*/
                },
            })
                .then(response => response.json())
                .then(data => {

                    if (data.error) {
                        dispatch(userAccountCreationFailed(data.error))
                    } else {

                        console.log('entity data', data)
                        dispatch(userAccountCreated(data))
                    }

                })
        }

    }
}

const createAccount = (data) => {

  return (dispatch, getState) => {

    const {email,password, givenName, familyName, organisation, noOfEmployees, note, jurisdiction, signupAnyway, noOfPayrolls, payrollSoftware, partner} = data

      // add noOfPayrolls, payrollSoftware, partner to cookie
        document.cookie = `noOfPayrolls=${noOfPayrolls};domain=.buddy.hr`
        document.cookie = `payrollSoftware=${payrollSoftware};domain=.buddy.hr`
        document.cookie = `noOfEmployees=${noOfEmployees};domain=.buddy.hr`

    const state = getState()
    dispatch(creatingAccount(noOfEmployees,organisation))

    if (state.quiz.answers.length > 0){
      data.note = state.quiz.answers.map((a,i) => `${state.quiz.questions[i]}\r\n${a}`).join('\r\n')
    }

    if (!(email == "" && state.my && state.my.profile && state.my.profile.email)){

      fetch(apiURL + '/authentication/create' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({email,password, givenName, familyName,signupAnyway,jurisdiction: jurisdiction ?? "MT", partner, organisation, noOfEmployees, noOfPayrolls, payrollSoftware}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {

        if (data.error){
          dispatch(userAccountCreationFailed(data.error))
        } else {

          console.log('entity data',data)
          dispatch(userAccountCreated(data))

          // once account created let's creat the demo account
          fetch(apiURL + '/demo/create' , {
              credentials: 'include',
              method: 'POST',
              body: JSON.stringify({signupAnyway,jurisdiction: jurisdiction ?? "MT", organisation, noOfEmployees, noOfPayrolls, payrollSoftware}),
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                /*'Organisation': getState().currentOrganisation,*/
              },
          })
          .then(response => response.json())
          .then(data => {
            console.log('entity data',data)
            dispatch(demoAccountCreated(data))

            // once account created let's creat the demo account

          })
        }

      })
    } else if (state.my.profile.isHR == 0){
      fetch(apiURL + '/demo/create' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({signupAnyway,jurisdiction: jurisdiction ?? "MT"}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        console.log('entity data',data)
        dispatch(demoAccountCreated(data))

        // we can redirect as account already existed
        window.location.href = appUrl()

      })
    }

    const dealEmail = email && email != '' ? email : state.my.profile.email


    fetch(apiURL + '/authentication/createDeal' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({signupAnyway, email: dealEmail, organisation, noOfEmployees, noOfPayrolls, payrollSoftware, note: data.note, stageID: jurisdiction == "UK" ? 15 : 33}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('acDeal',data)
      dispatch(acDealCreated(true))
    })
  }
}


const saveUserPersonalDetails = (response,attempt,userData) => ({
  type: Types.CREATE_ACCOUNT_USER_UPDATED,
  payload: response,
  attempt,
  userData
});


const updatingUserDetails = (response,attempt,userData) => ({
  type: Types.CREATE_ACCOUNT_USER_UPDATING
});

const updateUserDetails = (data) => {
  return (dispatch, getState) => {

    const {email,name,surname,phone} = data

    const state = getState()
    dispatch(updatingUserDetails(true))

    if (!((name && name == '') && state.my && state.my.profile && (state.my.profile.givenName || state.my.profile.name))){
      console.log('name',name,state.my.profile)
      fetch(apiURL + '/authentication/update' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({email,name,surname,phone}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        console.log('entity data',data)
        dispatch(saveUserPersonalDetails(data,true,{email,name,surname,phone}))

        const newState = getState()

        if (newState.createAccount.demoAccountCreated){
          // we can redirect as account already existed
          window.location.href = appUrl()
        }

      })
    } else {

    }
  }
}

const updateLead = (data) => {
  return (dispatch, getState) => {

    const {email,name,surname,phone,street,city,postcode} = data

    const state = getState()
    // dispatch(loggingIn(true))

    if (!((name && name == '') && state.my && state.my.profile && (state.my.profile.givenName || state.my.profile.name))){
      console.log('name',name,state.my.profile)
      fetch(apiURL + '/authentication/updateLead' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({email,name,surname,phone,street,city,postcode}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        console.log('entity data',data)
        dispatch(saveUserPersonalDetails(data,true,{email,name,surname,phone,street,city,postcode}))
      })
    } else {

    }
  }
}



const savingLead = (data) => ({
  type: Types.CREATE_ACCOUNT_SAVING_LEAD,
  data
});

const savedLead = (response,label,linkedInTrackingId) => ({
  type: Types.CREATE_ACCOUNT_SAVED_LEAD,
  payload: response,
  label,
  linkedInTrackingId
});

const saveLead = (data,label,linkedInTrackingId) => {
  return (dispatch, getState) => {

    // just forward all no need to extract
    // const {email,name,surname,phone,organisation,noOfEmployees,list} = data

    const state = getState()
    dispatch(savingLead(data))

    if (state.quiz.answers.length > 0){
      data.note = state.quiz.answers.map((a,i) => `${state.quiz.questions[i]}\r\n${a}`).join('\r\n')
    }

    fetch(apiURL + '/authentication/saveLead' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(savedLead(data,label,linkedInTrackingId))
      // dispatch(contactInList({email: data.email}))
    })
  }
}

const inList = (response) => ({
  type: Types.CREATE_ACCOUNT_CONTACT_LISTS,
  payload: response,
});


const contactInList = (data) => {
  return (dispatch, getState) => {

    // just forward all no need to extract
    // const {email,name,surname,phone,organisation,noOfEmployees,list} = data

    const state = getState()

    const list = data.list

    fetch(apiURL + '/authentication/contactLists' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(inList(data))
    })
  }
}

const subscribingToWebinars = () => ({
  type: Types.CREATE_ACCOUNT_WEBINAR_SUBSCRIBING
});

const subscribedToWebinars = (response) => ({
  type: Types.CREATE_ACCOUNT_WEBINAR_SUBSCRIBE,
  payload: response,
});

const subscribeToWebinar = (data) => {
  return (dispatch, getState) => {

    dispatch(subscribingToWebinars())

    const state = getState()

    fetch(apiURL + '/authentication/subscribeToWebinar' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(subscribedToWebinars(data))
    })
  }
}

const tagAdded = (response) => ({
  type: Types.CREATE_ACCOUNT_ADD_TAG,
  payload: response,
});

const addTag = (data) => {
  return (dispatch, getState) => {

    dispatch(subscribingToWebinars())

    const state = getState()

    fetch(apiURL + '/authentication/addTag' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(tagAdded(data))
    })
  }
}


const Actions = {
  createAccount,
  updateUserDetails,
  updateLead,
  saveLead,
  contactInList,
  subscribeToWebinar,
  addTag,
    createAccountForServices,
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions
